import { useTranslation } from 'react-i18next';

import { Modal, ModalProps } from '@mantine/core';
import { Loader } from '@mantine/core';

import styles from './GUSLoadingModal.module.css';

const GUSLoadingModal = (props: ModalProps) => {
   const { t } = useTranslation();

   return (
      <Modal centered size={600} {...props} styles={{ title: { fontFamily: 'Source Sans Pro' } }}>
         <div className={styles.contentContainer}>
            <Loader style={{ marginBottom: 24 }} color="var(--primary-green)" />
            <div>
               <p>{t('gus.loading.title')}</p>
               <p>{t('gus.loading.subtitle')}</p>
            </div>
         </div>
      </Modal>
   );
};

export default GUSLoadingModal;
